import React, {Fragment} from 'react'
import { currentLang } from '../../../utils/functions';
import { useTranslation } from 'react-i18next';
import {Link, useHistory, useLocation} from 'react-router-dom';
import {replace} from 'lodash';

const CategoryItem = ({id, name, icon, number, active, key, parentCallback, defaultCategory, activeCategory, filter}) => {
    const history = useHistory();
    let location = useLocation();
    const { t } = useTranslation();
    let urlpaths = replace(location.pathname, '/'+currentLang()+'/', '').split('/');
    if(urlpaths.length > 2 || (urlpaths[0].length > 1  && urlpaths[0] != t("menu.animal"))){
        var url = "/"+currentLang()+"/"+urlpaths[0]+"/"+t("menu.animal")+"/"+t(filter);
        
    }else{
        var url = "/"+currentLang()+"/"+t("menu.animal")+"/"+t(filter);
        
    }
  
    return (
        <Link to={url} key={key} className={`category__item ${(activeCategory == 1 || activeCategory === id) ? "active" : ""}`}>
            <div className="body">
                <figure className={icon}></figure>
                <h3>{name}</h3>
                {/* <div className="category__number">{number}</div> */}
            </div>
        </Link>
    )
}

export default CategoryItem
